export default "/_next/static/media/news-author-03.126d88aa91f6acf5629f087db16a7174.jpg";